export default function React_ES6_Classes() {
  return (
    <div>
      <h1>React_ES6_Classes Component</h1>
      <p>This is the React_ES6_Classes tutorial page.</p>
    </div>
  );
}
